export default {
sets: `Súprav`,
stats: `Štatistika`,
discover: `Objaviť`,
guides: `Príručka`,
settings: `nastavenie`,
unsupportedBrowserBody: `Faktivé nepodporujú tento prehliadač. Stiahnite si najnovšiu verziu Chrome alebo Opera alebo si stiahnite našu aplikáciu iPhone alebo Android`,
unsupportedBrowserTitle: `Nepodporovaný prehliadač`,
noData: `Žiadne údaje, ktoré sa majú zobraziť`,
contactUsTitle: `Rád počúvame, ako naši používatelia používajú našu aplikáciu a ako sa môžeme vylepšiť. Zložte nám správu s akýmikoľvek dopytmi, ako sú požiadavky na funkcie alebo správy o chybe`,
rateAppStore: `Sadzba v aplikácii Appstore`,
rateGoogle: `Hodnotiť v službe Google Play`,
close: `Zavrieť`,
shareFriends: `Zdieľať s kamarátmi`,
noCardsQ: `Nemáte žiadne kartičky?`,
noCardsS: `Vyberte z našej zbierky, aby ste mohli začať`,
suggestSet: `Navrhovať`,
createOwn: `Vytvor svoju vlastnú`,
search: `Vyhľadávanie`,
loading: `Načítava`,
words: `Slova`,
downloads: `K stiahnutiu`,
export: `Export`,
import: `Dovoz`,
importing: `Import ... Nezatvárajte aplikáciu`,
importPreview: `Ukážka importu`,
howQuizlet: `Ako importovať z kvízletu`,
cards: `Karty`,
importPreviewStatus: `__ Podmienky sú pripravené na pripojenie k existujúcim ___ kartám`,
importPaste: `Vložte svoje karty do vyššie uvedeného textarea`,
setTotalLimitReached: `V štúdiu môžete mať iba 3 000 kariet`,
studying: `Študovať`,
learnt: `Učil sa`,
mastered: `Zvládnutý`,
new: `Nový`,
noTerm: `Žiadny termín`,
noDef: `Žiadna definícia`,
cardSaved: `Uložená karta`,
reviews: `Recenzie`,
practices: `Postupy`,
flashcards: `Karta`,
alerts: `Výstrahy`,
corrects: `Korigovať`,
mistakes: `Chyby`,
reviewCycle: `Cyklus`,
reviewsLeft: `Recenzie vľavo`,
lastReview: `Posledná recenzia`,
nextReview: `Ďalšia recenzia`,
hideHistory: `Skryť celú históriu`,
showHistory: `Ukážte úplnú históriu`,
strength: `Pevnosť`,
star: `Hviezda`,
image: `Obraz`,
tag: `Označenie`,
added: `pridaný`,
removed: `odstránený`,
reviewedFrom: `Recenzované z __`,
notifications: `Oznámenia`,
reviewedPractice: `Recenzované __ ___ praxou`,
successfully: `úspešne`,
unsuccessfully: `neúspešne`,
termUpdated: `Termín aktualizovaný`,
defUpdated: `Definícia aktualizovaná`,
flashcardCreated: `Vytvorená flashcard`,
dropboxImage: `Musíte povoliť synchronizáciu Dropboxu na pridanie obrázkov`,
deleteImgConfirm: `Ste si istí, že chcete tento obrázok odstrániť?`,
uploading: `Nahrávanie`,
save: `Zachrániť`,
uploadImageFail: `Nepodarilo sa nahrať obrázok`,
imageUploaded: `Nahraný obrázok`,
setNotFound: `Studyset sa nenašiel!`,
notEnoughCards: `Nie dosť kariet!`,
of: `__ ___`,
on: `Na`,
off: `Vypnutý`,
auto: `Automatický`,
manual: `Manuálny`,
pronounce: `Vysloviť`,
practiceCompleted: `Túto prax ste dokončili`,
closePractice: `Úzka prax`,
autoplay: `Automatická plocha`,
secFlipSecNext: `__ Sec Flip, ___ sec Next`,
autopronounce: `Automaticky`,
onlyTerm: `Iba termín`,
onlyDef: `Iba definícia`,
termAndDef: `Termín a definícia`,
savePractice: `Uložiť prax?`,
continueLater: `Pokračovať`,
deletePractice: `Vymazať prax`,
term: `Termín`,
def: `Definícia`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Cieľ preskúmať`,
dailyGoal: `Denný cieľ`,
edit: `Upraviť`,
setUp: `Nastaviť`,
noRecentPractice: `Nemáte žiadne nedávne praktiky`,
continueLastReview: `Pokračujte v poslednej recenzii`,
dueCards: `Splatné karty`,
studyNow: `Študovať`,
newCards: `Nové karty`,
terms: `podmienky`,
defs: `definícia`,
validCardsOf: `Je možné praktizovať iba __ vybratých kariet ___`,
reviewCards: `Recenzia`,
customizePractice: `Prispôsobiť prax`,
next: `Ďalšie`,
iWasRight: `mal som pravdu`,
printProAlert: `Kúpte si predplatné Pro Tlačenie viac ako 20 kartových kariet`,
print: `Tlač`,
printWidth: `Šírka termínu`,
printFont: `Veľkosť písma`,
printBorder: `Hranica`,
printMargin: `Marža`,
printPadding: `Čalúnenie`,
preparingFile: `Príprava súboru`,
notificationsBlocked: `Upozornenia nie sú povolené, povoľujete upozornenia z nastavení telefónu`,
ranOutOfWords: `Došli karty, reštartujte prax, aby ste mohli začať znova`,
ranOutOfWordsShort: `Dôjdu slová`,
ranOutOfWordsBody: `Otvorte aplikáciu a naplánujte si nové slová`,
proIncreaseNotifications: `Celkové oznámenia môžete zvýšiť z 10 na 50 v prémiovej verzii.`,
schedule: `Plán`,
frequency: `Časť`,
mode: `Režim`,
tM1: `1 minúta`,
tM2: `2 minúty`,
tM5: `5 minút`,
tM10: `10 minút`,
tM15: `15 minút`,
tM30: `30 minút`,
tH1: `1 hodina`,
tH2: `2 hodiny`,
termPassive: `Pojem pasívny`,
termActive: `Aktívny termín`,
defPassive: `Defívny`,
defActive: `DEF aktívny`,
scheduledIn: `Naplánované do __ min.`,
scheduledAlertsProT: `Zvýšte plánovateľné upozornenia s Pro`,
scheduledAlertsProB: `Plánované výstrahy môžete zvýšiť z 10 na 50 s balíkom Pro`,
seeFeatures: `Pozri funkcie`,
defAndTerm: `Definícia a termín`,
termHoldDef: `Termín, držte sa, aby ste odhalili definíciu`,
defHoldTerm: `Definícia, držte sa, aby ste odhalili termín`,
notificationType: `Typ oznámenia`,
copyToClipboard: `Skopírovať do schránky`,
enterAuthCode: `Zadajte svoj autorizačný kód`,
invalidCode: `Poskytnutý neplatný kód`,
copied: `Skopírované!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Klepnutím objavíte všetky prémiové funkcie, aby ste sa efektívnejšie dozvedeli svojím vlastným tempom`,
promoBtn: `Objavte všetky funkcie`,
setDropboxH2: `Synchronizácia Dropboxu`,
setDropboxPOff: `Povoľte synchronizáciu Dropboxu, aby ste udržali svoje sady, kartičky, značky a pokrok zálohované a aktualizované vo všetkých vašich zariadeniach.`,
setDropboxPOn: `Vaše údaje sú zálohované a synchronizované na vašich zariadeniach.`,
setDropboxBtn: `Synchronizovať`,
status: `Postavenie`,
syncNow: `Synchronizovať teraz`,
contact: `Kontakt`,
contactUs: `Kontaktuj nás`,
useFromBrowser: `Používajte z prehliadača`,
useFromBrowserMsg: `Navštívte Flashcardsmadesimple.com v počítači a obnovte svoje karty a licenciu tým, že povolíte synchronizáciu Dropboxu`,
termsPrivacy: `Podmienky a súkromie`,
dailyReviewGoal: `Cieľ dennej kontroly`,
numberTerms: `Počet podmienok`,
selectTerm: `Vyberte s náznakom termínu`,
selectDef: `Vyberte s náznakom definície`,
pronounceTerm: `Vyslovte s náznakom termínu`,
pronounceDef: `Vyslovte s náznakom definície`,
typeTerm: `Napíšte s náznakom termínu`,
typeDef: `Typ s náznakom definície`,
quizTypes: `Preferované typy kvízov`,
spacedRepetition: `Rozvrhový harmonogram opakovania`,
spacedRepetitionP: `Opakovanie rozmiestnenia vám umožňuje zvládnuť slová s menším úsilím tým, že postupne rozmiestnite čas kontroly. Predvolený rozvrh je 1-3-7-15-31 dní, ale môžete nastaviť aj vlastný.`,
spacedRepetionScheduleItem: `__ dni po ___ recenzia (deň ____)`,
atLeastOneSchedule: `Vyžaduje sa aspoň jeden harmonogram`,
revisionLimitReached: `Dosiahli ste maximálny počet revSision`,
addReviewSchedule: `Pridajte nový rozvrh kontroly`,
autoMarkLearnt: `Auto Mark sa naučil po`,
autoMarkMastered: `Automatické značenie zvládli po`,
tagManager: `Správca značky`,
delete: `Vymazať`,
addTag: `Pridajte novú značku`,
tagDeletionH: `Vymazanie značky`,
tagDeletionP: `Ste si istí, že chcete túto značku odstrániť?`,
cancel: `Zrušiť`,
daysAfterLastReview: `Dni po poslednej recenzii`,
linkDropbox: `Prepojenie Dropbox`,
startSync: `Sync`,
starred: `Hral`,
images: `snímky`,
tags: `Značky`,
types: `Tyčinka`,
activeDays: `Aktívne dni`,
inactiveDays: `Neaktívne dni`,
longestStreak: `Najdlhší pruh`,
dailyGoalsCompleted: `Denné ciele dokončené`,
dailyGoalsFailed: `Denné ciele zlyhali`,
typePairs: `Dvojice`,
reviewTypes: `Typy recenzií`,
typePractice: `Precvičiť`,
pronouncePractice: `Vyslovovať`,
selectPractice: `Vyberať prax`,
notificationReview: `Preskúmanie oznámenia`,
flashcardReview: `Recenzia`,
studyset: `Štúdium`,
enterStudysetName: `Zadajte názov pre svoj Studyset`,
studysetName: `Zadajte meno set`,
termType: `Typ typu / lang`,
defType: `Typ definície / lang`,
exportCards: `Vývozné karty`,
importCards: `Import`,
quiz: `Kvíz`,
showingOutOfCards: `Zobrazuje __ z ___ kariet`,
showingAllCards: `Zobrazenie všetkých kariet, napíšte do vyššie uvedeného vyhľadávacieho panela alebo klepnite na akékoľvek značky a filtrujte`,
recording: `Nahrávanie`,
downloadSet: `Pridajte do mojich sád`,
addNewCard: `Pridajte novú kartu`,
saveStudyset: `Uložiť študijnú súpravu`,
studysetDeletionH: `Vymazanie Studyset`,
studysetDeletionP: `Ste si istí, že chcete odstrániť tento Studizet, to tiež odstráni všetky obsiahnuté karty.`,
cardDeletionH: `Vymazanie`,
cardDeletionP: `Ste si istí, že chcete túto kartu odstrániť`,
cardLimitReached: `V štúdiu môžete mať iba 3 000 kariet`,
limitExceeded: `Limit prekročený`,
atLeastTenCards: `Pridajte aspoň 10 kariet, aby ste mohli začať s postupmi`,
searchInAll: `Vyhľadajte vo všetkých súboroch štúdie`,
noMatch: `Žiadna zhoda`,
atLeastThreeChars: `Ak chcete vyhľadať najmenej 3 znaky`,
noSets: `Žiadne sady`,
startingSync: `Začatie synchronizácie`,
noSetsP: `Ak chcete začať, vyberte z možností nižšie`,
startingSyncP: `Dostávame vaše údaje z Dropboxu, môže to chvíľu trvať`,
createNewStudyset: `Vytvorte nový Studyset`,
restoreFromBackup: `Obnoviť zo záložného súboru`,
setStarterPacks: `Študentské štartéry`,
selectPracticeType: `Vyberte typ praxe`,
noDueCards: `Zatiaľ nie sú k dispozícii žiadne nápisy, karty, ktoré ste si predtým preskúmali, sa tu začnú objavovať po vybranom rozvrhu opakovania, ktoré vám pomôžu zvládnuť slová s menším úsilím a časom`,
noNewCards: `Žiadne nové karty na štúdium`,
subscriptionH: `Kúpte si Pro, aby ste si užili všetky funkcie a podporili nepretržitý rozvoj.`,
buyLifetimePro: `Kúpte si celoživotný profesionál pre __`,
restorePurchase: `Obnoviť nákup`,
termsPrivacyC: `Podmienky a zásady ochrany osobných údajov`,
licenceShare: `Ak ste si zakúpili licenciu z iného zariadenia, môžete ju zdieľať s týmto zariadením tým, že povolíte synchronizáciu Dropbox na oboch zariadeniach`,
enterTagName: `Zadajte názov značky`,
invalidName: `Neplatné meno`,
create: `Vytvárať`,
name: `názov`,
tagName: `Názov vašej značky`,
color: `Farebný`,
back: `späť`,
rowSeparator: `Oddeľovač riadkov`,
termDefSeparator: `Term - def separátor`,
output: `Výkon`,
inputCards: `Vstupné karty`,
review: `Preskúmanie`,
language: `Jazyk`,
archiveReversible: `Archív (reverzibilný z nastavení)`,
deletePermanent: `Odstrániť (nezvratné)`,
archivedCards: `Archivované karty`,
masteredCards: `Zvládnutý karty`,
due: `Náležitý`,
reviewed: `Recenzovaný`,
markReviewed: `Recenzovaný`,
markMastered: `Zvládnuť`,
forXYCards: `pre __ ___ karty`,
createdAtSortBy: `Dátum vytvorenia`,
lastReviewedSortBy: `Posledný dátum preskúmania`,
reviewCountSortBy: `Počet recenzií`,
strengthSortBy: `Pevnosť`,
termSortBy: `Abecedný termín`,
definitionSortBy: `Abecedná def.`,
ascSortBy: `Vzostupný`,
descSortBy: `Zostupný`,
featureSync: `Študujte si čokoľvek, kdekoľvek, kedykoľvek, so svojimi kartičkami synchronizovanými vo všetkých vašich zariadeniach`,
featureSpacedrepetition: `Pozrite sa na svoj celkový pokrok a vráťte sa k praktizovaniu toho, čo potrebujete na precvičenie`,
featureNotifications: `SPRETALI SVOJE SVOJE bez toho, aby ste dokonca otvorili aplikáciu s flexibilnými upozorneniami`,
featureFlashcards: `Autotoplay karty, keď sú ruky alebo oči zaneprázdnené, ale stále máte nepoužitú pozornosť`,
featureQuiz: `Zodpovedajte, vyhláskujte, počúvajte alebo vyberte precvičenie svojich kartičiek`,
featureStats: `Získajte lepší prehľad o svojich kartách a výsledkoch a vyhľadajte všetky svoje sady kariet`,
featureImport: `Nikdy nebudeme ukladať žiadne údaje od vás a môžete ľahko exportovať a importovať všetky svoje údaje`,
featurePrint: `Doprajte si nejaké učenie tlačením svojich kartičiek a preživujte si vlastnú študijnú súpravu`,
splashIntro: `Preštudujte si všetky svoje kartičky kdekoľvek vo svojom tempe a štýle`,
selectSortOrder: `Triediť objednávku`,
selectSortProp: `Triediť nehnuteľnosť`,
applyFilters: `Appant Filters`,
selectSetType: `Čo chcete trénovať?`,
getStarted: `Začať`,
tapToUnarchive: `Klepnite na karty, ktoré chcete odohnať`,
untitled: `Bez názvu`,
sortHintNew: `Uvidíte karty, ktoré boli vytvorené pred najdlhším časom ako prvé`,
sortHintDue: `Uvidíte karty, ktoré boli splatné najdlhšie ako prvé`,
sortHintOther: `Uvidíte karty, ktoré neboli študované najdlhšie prvé`,
flashcardsWhen: `, keď sú vaše ruky alebo oči zaneprázdnené, dokonca aj pri počúvaní hudby / podcastov`,
notificationsWhen: `, lebo keď ste vonku a chcú len rýchle študijné kúsky`,
quizWhen: `, lebo keď môžete venovať plnú pozornosť pri štúdiu, zvládnuť svoje karty`,
features: `Vlastnosti`,
ratings: `Hodnotenie`,
notificationDailyCatchUpBody: `NOVINKA: __, splatné: ___, Štúdium: ____, Dozvedené: _____, zvládnutie: ______`,
notificationDailyCatchUpTitle: `Každodenné chytenie`,
reviewedJN: `Recenzované práve teraz`,
customUpdated: `Vlastný text aktualizovaný`,
customTextField: `Synonymá, príklady atď.`,
field: `Lúka`,
link: `Spojenie`,
backToParentCard: `Späť na rodičovskú kartu`,
discard: `Vyradiť`,
failedImageLoad: `Nepodarilo sa načítať obrázok, uistite sa, že ste pripojení k internetu`,
printDIYLabel: `Diy si vlastne pripravuje nastavenie štúdie založené na tvorivých papieroch, zdieľajte s nami svoju tvorbu a dostanete sa do aplikácie.`,
reviewGraphChart: `Preskúmanie frekvencie`,
langNotSet: `Jazyk nie je nastavený`,
pronouncationLangInfo: `Ak chcete povoliť výslovnosť, musíte zvoliť jazyk pojmu a definície. Vedľa jazykov sa zobrazí znak reproduktora, ak vaše zariadenie podporuje tento jazyk`,
clearFilters: `Jasný filter`,
subFreeUnlimited: `Neobmedzené štúdium, kartičky, postupy, vyhľadávanie a synchronizácia`,
customFields: `Vlastné polia`,
subLinks: `Odkazy na kartu`,
subPrint: `Tlačiť`,
subNotifications: `Oznámenie pred tým, ako budete musieť otvoriť aplikáciu`,
subCardsStudysets: `Karty`,
subRevisionCycles: `Cykly vlastných revízií`,
subscriptionHEnd: `Inovácia na Pro nám ukazuje, že zistíte, že naša tvrdá práca je hodnotná a dáva nám povzbudenie a kávu, aby sme sa naďalej zlepšovali a vytvárali nové úžasné veci.`,
subFree: `zadarmo`,
subPro: `Protest`,
guideSpacedRepetition: `Ako pracuje na opakovaní a typoch praxe SPARE`,
guideSearch: `Hľadanie a filtrovanie`,
guideSync: `Povoľte zálohovanie a synchronizácia vo vašich zariadeniach`,
guidePronunciation: `Povoliť výslovnosť`,
guideImport: `Import kariet z výstupných zdrojov`,
guideAccess: `Kto má prístup k mojim údajom?`,
guideData: `Aké údaje zhromažďujeme?`,
guideContact: `Potrebujete pomoc s niečím iným? Napíš nám`,
arrowStrength: `Nastavte, ako dobre viete túto kartu`,
arrowImage: `Pridať obrázky`,
arrowField: `Pridajte ďalšie vlastné textové polia`,
arrowTag: `Pripevniť značky`,
arrowStar: `Označte ako obľúbené`,
arrowLink: `Odkaz na iné karty`,
arrowGoal: `Stanovte si cieľ dennej kontroly sami`,
arrowDue: `Študovať slová, ktoré sa majú preskúmať`,
arrowNew: `Študijné karty, ktoré ešte neboli preskúmané`,
arrowMastered: `Ak nemáte žiadne splatné alebo nové karty, môžete skontrolovať zvládané karty, aby ste ich udržali zvládnuté`,
arrowImport: `Importujte svoje existujúce kartičky`,
arrowNewCard: `Pridajte nové kartičky`,
dropboxStep1: `1. Získajte prístupový kód z Dropboxu prihlásením`,
dropboxStep1Btn: `Prihláste sa s Dropboxom`,
dropboxStep2: `2. Zadajte prístupový kód nižšie`,
dropboxStep2Input: `Sem vložte kód`,
dropboxStep3: `3. Spustite synchronizáciu`,
alreadyLinked: `Už prepojené, klepnutím na odnesenie`,
selectCardsToLink: `Vyberte karty na prepojenie`,
unsupportedLangP: `Vyberte jazyk, ktorý podporuje vyslovenie z nastavení set`,
links: `Odkazy`,
emailUs: `Pošlite nám e -mail`,
whatsappUs: `Whatsapp nás`,
printMinHeight: `Min. výška riadku`,
exportType: `Exportovať typ súboru`,
generateFileText: `Vygenerovať súbor`,
generatatingFile: `Generovanie súboru`,
verySmall: `Veľmi malé`,
small: `Malý`,
normal: `Normálny`,
big: `Veľký`,
veryBig: `Veľmi veľký`,
repeatNTimes: `Opakovať __ krát`,
pause: `Pauza`,
for: `pre`,
say: `Povedať`,
defShort: `Definovať.`,
times: `časy`,
autoplayPreferences: `Nastavte preferencie AutoPlay`,
autoPlay1: `Pozastaviť sa po predchádzajúcom slove`,
autoPlay2: `Počet termínových vyhlásení`,
autoPlay3: `Pauza pred odhalením definície`,
autoPlay4: `Počet vyhlásení o definícii`,
autoPlay5: `Pauza pred ukázaním nasledujúceho slova`,
autoPlay6: `Opakujte rovnakú kartu`,
startAutoPlay: `Spustite automatickú hodnotu`,
autoPlayOffConfirm: `Vypnite autoplay, aby ste povolili manuálne ovládacie prvky`,
turnOff: `Vypnúť`,
keepPn: `Pokračuj`,
foundIn: `Nájdený v __`,
repeat: `opakovať`,
stop: `Zastavenie`,
listenInBreak: `Vedel si? Môžete počúvať hudbu / podcasty v prestávkach`,
contextSearch: `Kontextové vyhľadávanie`,
contextSearchText: `Získajte príklady toho, ako __ sa používa v rôznych vetách`,
transalteSearch: `Preložiť`,
translateSearchText: `Preložiť __ do ___`,
synonymSearch: `Vyhľadávanie synonymum`,
synonymSearchText: `Vyhľadajte synonymá __`,
selectToAdd: `Vyberte výsledky, ktoré chcete pridať na túto kartu`,
addToCard: `Pridajte vybranú kartu`,
hideFromPractice: `Schovať sa`,
setLanguageRequired: `Vyberte jazyk pojmov a definícií v podrobnostiach Studizet`,
fieldNeedsText: `Pred vyhľadaním zadajte niečo do tohto poľa`,
possibleDupe: `Možný duplikát`,
loadNextXCards: `Načítajte ďalšie __ karty`,
repeatPractice: `Opakujte tieto karty __`,
keepScreenOnInfo: `Možno budete musieť upraviť svoje automatické nastavenie, aby ste pri automatickom rozhraní udržali obrazovku.`,
siteLoginH2: `Účet SFM`,
siteLoginP: `Môžete použiť svoje kartičky vyrobené jednoduchým účtom na zdieľanie svojich kartičiek so svojimi priateľmi, vašimi študentmi alebo celú komunitu.`,
logOut: `Odhlásiť sa`,
logIn: `Prihlásiť sa`,
createAccount: `Vytvoriť nový účet`,
signUp: `Prihlásiť Se`,
username: `Užívateľské meno`,
email: `E -mail`,
password: `Heslo`,
networkError: `Chyba siete`,
fillAllDetails: `Vyplňte všetky podrobnosti`,
noUserWithDetails: `Žiadny užívateľ nenašiel s zadanými podrobnosťami`,
userAlreadyExists: `Daný e -mail alebo používateľské meno už existuje`,
signUpOrLoginToCont: `Zaregistrujte sa alebo sa prihláste a pokračujte?`,
atLeastOneCardToShare: `Na zdieľanie je potrebná aspoň jedna karta`,
publishingStudyset: `Vydavateľstvo`,
updatesDetected: `Zistené aktualizácie, chcete pokračovať v aktualizácii miestnych údajov? (Odstránené: __, aktualizované: ___, nové: ____)`,
updatesApplied: `Uplatňované aktualizácie`,
alreadyUpToDate: `Už aktuálne`,
practiceTypeArrow: `Objavte rôzne spôsoby praženia`,
share: `zdieľam`,
sharingModalIntro: `Podeľte sa o svoje kartičky v tejto sade so svojimi priateľmi, svojimi študentmi alebo s celou komunitou.`,
whatIsShared: `Čo je zdieľané`,
whatIsNotShared: `Čo nie je zdieľané`,
whatIsSharedText: `Nastavte názov, nastavený termín jazyk, jazyk definície, všetky zahrnuté karty s výrazmi, definíciami, vlastnými textovými poliami a obrázkami`,
whatIsNotSharedText: `Všetky silné stránky karty, hviezdy, odkazy, značky a história recenzie`,
checkForSharedUpdates: `Skontrolujte aktualizácie od tvorcu`,
fetchUpdates: `Načítať aktualizácie`,
youSharedStudyset: `Zdieľali ste tento Studyset`,
publishChanges: `Uložiť a zverejniť zmeny`,
redeem: `Uplatniť`,
noAds: `Žiadne reklamy`,
dupeDetection: `Detekcia duplikátu`,
coffeeFeature: `Káva, aby nám pomohla vyvíjať ďalšie funkcie`,
shareLink: `Zdieľať odkaz`,
coffeeForUs: `Dostanete celoživotnú licenciu iba pre __, ktorá dáva Emily 6 káv, Dominik 3 Coffees a Russ 3 Coffees, ktoré nás podnecujú asi 39 hodín, aby sa táto udalosť aplikácie zlepšila`,
sharingCards: `Zdieľanie kariet`,
published: `Publikovaný`,
alreadyHaveAccount: `Máte už účet?`,
notAlreadyHaveAccount: `Nemáte ešte účet?`,
startPractice: `Začatie praxe`,
selectQuizTypes: `Vyberte typy kvízov`,
correct: `Oprávnený`,
incorrect: `Nesprávny`,
yes: `Áno`,
no: `Nie`,
levelSilver: `Úroveň striebra __`,
levelGold: `Úroveň zlata __`,
levelPlatinum: `Úroveň platiny __`,
levelDiamond: `Úroveň diamantu __`,
levelJade: `Jade úroveň __`,
reviewsLeftGoal: `__ Recenzie na denný cieľ`,
dailyGoalAchieved: `Denný cieľ`,
share: `zdieľam`,
rateApp: `Aplógna hodnota`,
allStats: `Všetky štatistiky`,
reviewTimeError: `Časový limit po chybe`,
reviewTimeCorrect: `Časový limit po správnom`,
pronounceTermAfterReview: `Výrazové obdobie po preskúmaní`,
pronounceDefinitionAfterReview: `Definícia vyslovenia po preskúmaní`,
practice: `Prax`,
notificationsScheduledInfo: `__ Boli naplánované upozornenia, aplikáciu môžete zatvoriť teraz`,
wellDone: `Dobre`,
keepItUp: `Len tak ďalej`,
youRock: `Ide ti to`,
niceOne: `Pekné`,
lnSelect: `Zvoľ jazyk`,
sampleData: `Žiadne recenzie, ktoré ukazujú vzorové údaje`,
reviewFreq: `Preskúmanie frekvencie`,
selectPractice: `Cvičenie: Vyberte`,
spellPractice: `Prax: kúzlo`,
connectPractice: `Prax: Connect`,
languages: `Jazyk`,
languagesPairs: `Jazykové páry`,
shareArrow: `Zdieľajte set s priateľmi, študentmi alebo celú komunitu`,
cardsPerRound: `Karty`,
showAll: `Ukázať všetko`,
supportedLangsVary: `Podporované jazyky sa líšia`,
practiceWithoutSave: `Prax nie je uložená`,
practiceWithoutSaveBody: `Do svojej zbierky ste nepridali tento Studizet, chcete ho pridať teraz, aby ste uložili pokrok v štúdiu?`,
saveSetNow: `Uložte karty do svojej zbierky`,
continueWithoutSaveSave: `Začnite cvičiť bez uloženia`,
createdBy: `Vytvoril`,
setSavedToYourCollection: `Študijná súprava uložená do vašej zbierky`,
accountBackupDisclaimer: `Upozorňujeme, že tento účet sa dá použiť iba na zdieľanie štúdiovýchetov s ostatnými a nemožno ho použiť na zálohovanie alebo synchronizáciu vašich štúdiových súčtov alebo kartičiek. Na synchronizáciu a zálohovanie všetkých vašich údajov použite Dropbox Sync`,
syncEnabled: `Povolená synchronizácia, načítajte prebiehajúci obsah`,
searchAllSets: `Vyhľadávacie štúdie od ostatných používateľov`,
anyLanguage: `Akýkoľvek jazyk`,
trendingIn: `Trend`,
manualBackups: `Manuálna záloha`,
manualBackupCreate: `Vytvorte manuálne zálohovanie`,
confirmManualImport: `Ste si istí, že chcete nahradiť všetky aktuálne údaje touto zálohou? Toto sa odporúča iba na nových zariadeniach bez akýchkoľvek údajov`,
importFromManualBackup: `Import z zálohy`,
imgOfflineSets: `Obrázky automatického download pre offline učenie`,
unsupportedDeviceCache: `Táto funkcia je k dispozícii iba z aplikácie pre iOS alebo Android`,
shareChanges: `Zdieľať __ zmeny`,
publiclySearchable: `Prehľadávatelia používateľov`,
description: `Opis`,
restoreFromDropboxBackup: `Obnoviť zálohu Dropbox`,
imageCacheStudysetSub: `[IOS & Android] Stiahnite si obrázok na štúdium offline`,
keywordsOrLangNeeded: `Musíte zadať niektoré kľúčové slová alebo jeden jazyk`,
dropboxAlreadyLinked: `Účet Dropbox je už prepojený`,
noSetUpdateAccess: `Nemáte prístup k úpravám tejto štúdie.`,
confirmSetOwnerLogin: `Ak ste si istí, že ste vlastníkom, skúste sa znova prihlásiť do svojho účtu.`,
uninitedRestriction: `Ak chcete uložiť svoj pokrok, najprv musíte pridať tento Studizet do svojej zbierky`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Nepodarilo sa konsolidovať úložisko`,
consolidateStorageDone: `Ukladací konsolidujte, pred prihlásením na nové zariadenie nechajte Dropbox až hodinu, aby ste dokončili odstránenie starých súborov.`,
consolidatingStorage: `Konsolidácia úložného priestoru ...`,
deleteAccount: `Zmazať účet`,
consolidateStorageDescription: `Táto operácia znovu preindeje vaše zálohovacie súbory, takže nastavenie nových zariadení bude rýchlejšie`,
consolidatingStorageConfirm: `Uistite sa, že všetky vaše zmeny už dokončili synchronizáciu, nesynchronizujte iné zariadenia, keď sa tento proces odohráva. Chceš pokračovať?`,
consolidateStorage: `Ukladanie ukladania`,


}